import React from 'react';

import '../../styles/pcr.scss';

export default ({ children }: { children: React.ReactNode }) => {
  return <div className="pcr-workflow-view">{children}</div>;
};
